import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import useShop from "./useShop";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from "sweetalert";
import {confirmAlert, errorAlert} from "../../Components/Alerts/BasicAlert";

export default function () {
    const {reset, handleSubmit, setErrors, shopFields, setData} = useShop();
    const {id} = useParams();
    const [shopId, setShopId] = useState(null)
    const navigate = useNavigate();

    useEffect(() => {
        axios.get(`/shops/${id}/edit`).then(res => {
            setData(res.data.data);
            setShopId(res.data?.shop?.id)
            reset(res.data?.shop);
        });
    }, []);

    const editShop = data => {
        const formData = new FormData();

        Object.entries(data).forEach(([property, value]) => {
            formData.append(`${property}`, value === 0 ? value : (value || ''));
        });

        formData.append("_method", "PATCH");

        axios.post('shops/' + data.id, formData)
            .then(function (res) {
                swal('Seller / Shop has been updated successfully!', {
                    icon: "success",
                });
                navigate("/shops");
            })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.errors || {});
                }
            });
    }

    const deleteShop = () => {
      confirmAlert('You want to delete shop?', handleDelete)
    };

    const handleDelete = () => {
      axios.delete(`/shops/${shopId}`).then(res => {
        swal('Seller / Shop has been deleted successfully!', {
          icon: "success",
        });
        navigate("/shops");
      })
        .catch(function (err) {
          const message = err.response?.data?.message;
          if (message) {
            errorAlert(message);
          }
        });
    }

    return (
        <Card title="Edit seller">
            <form className="form w-100" onSubmit={handleSubmit(editShop)}>
                {shopFields}
                <SubmitButton title="Update"/>
                <button type="button" onClick={() => deleteShop()} className="btn btn-lg btn-danger float-right" >
                  <i className="far fa-trash-alt"></i>
                  Delete Shop
                </button>
            </form>
        </Card>
    );
}